import { defineComponent } from 'vue'

export default defineComponent ({
    name: 'Traceability'
    , props: {
        createdAt: {
            type: String
            , required: false
            , default: () => ''
        }
        , name: {
            type: String
            , required: false
            , default: () =>  ''
        }
        , containTitle: {
            type: Boolean
            , required: false
            , default: () => false
        }
        , title: {
            type: String
            , required: false
            , default: () => ''
        }
        , subTitle: {
            type: String
            , required: false
            , default: () => ''
        }
        , collaborators: {
            type: Array
            , required: false
            , default: () => []
        }
    }
    , data: () => ({
        selectedCollaborator: []
        , currentPage: 1
        , motive: ''
    })
    , computed: {
         showTitle () { return !!this.title.length }
        , showSubTitle () { return !!this.subTitle.length }
        , showCollaborators () { return !!this.collaborators.length }
        , formatStateManagement () {
            return ({ status, core_employee =  {}, is_automatic_approval }) => {
                const employee = {
                    name: core_employee.name || ''
                    , role: core_employee.core_role ? core_employee.core_role.name : ''
                }
                const list = {
                    approved: is_automatic_approval ? 'Aprobación automatica' : `Aprobado por ${employee.name} (${employee.role})`
                    , pending: 'Pendiente'
                    , rejected: `Rechazado por ${employee.name} (${employee.role})`
                    , retraction: 'Retracción'
                }
                return list[status] ? list[status] : '<Sin Estado>'
            }
        }
        // ## NOMBRE DEL EMPLEADO QUE HACE LA MODIFICACION
        , getModifiedEmployeeName () {
             return ({ core_employee =  {} }) => {
                 return core_employee.name || ''
             }
        }
        , getDaysApproved () {
            return ({ days }) => {
                const filter = (array = Array, state = 'approved') => array.filter(({ status }) => status === state)
                const orderById = (array = Array) => array.sort((a, b) => a.id - b.id)
                return orderById(filter(days));
            }
        }
        , getLastDay () {
             return (array) => {
                 if (array.length === 0) return null
                 return array.slice(-1)[0].day || null
             }
        }
        , showPagination () {
             return this.totalItems > 1
        }
        , perPage () {
             return 1
        }
        , totalItems () {
             return this.collaborators.length
        }
        , startIndex () {
             return (this.currentPage - 1) * this.perPage
        }
        , endIndex () {
            return this.startIndex + this.perPage
        }
        , paginatedItems () {
            return this.collaborators.slice(this.startIndex, this.endIndex)
        }
        , showMotive () {
             return this.totalItems === this.currentPage
        }
        , validationMotive () {
             return (this.motive.length >= 5)
        }
        , canRetract () {
             return !!(this.selectedCollaborator.length !== 0 && this.validationMotive)
        }
    }
    , watch: {
        canRetract (newValue, oldValue) {
            if (newValue !== oldValue) this.$emit('change:canRetract', { can: this.canRetract })
        }
        , selectedCollaborator: {
            handler() {
               this.send()
            }
            , deep: true
        }
        , motive () {
            if (this.validationMotive) this.send()
        }
    }
    , methods: {
        approvedAll (collaborator) {
            this.getDaysApproved(collaborator).forEach(({ id }) => {
                document.getElementById(id).checked = true
                this.selectedCollaborator = [{ id: collaborator.id, day:id },...this.selectedCollaborator]
            })
            this.clearSelected()
            this.send()
        }
        , send () {
            const data = {
                license: this.selectedCollaborator
                , motive: this.capitalizeFirstLetter(this.motive)
            }
            this.$emit('change:daysRetraction', { days: data, can: this.canRetract })
        }
        , clearSelected () {
            this.selectedCollaborator = [...new Map(this.selectedCollaborator.map((item) => [item.day, item])).values()]
        }
    }
})